import { AxiosHttpClient } from 'api/axios';
import { useRepruaPatchApi } from 'api/shared_api_hooks';
import { BulkUpdateUserAuthorityForm } from 'entities/user_authority';
import { ApiSet, BaseResponse } from 'rac';

type UsersResponse = BaseResponse;

/**
 * 更新
 */
export function usePatchUserAuthorityApi(): ApiSet<UsersResponse> & {
  execute: (userAuthorityForm: BulkUpdateUserAuthorityForm) => void;
} {
  const api = useRepruaPatchApi<UsersResponse, BulkUpdateUserAuthorityForm>(new AxiosHttpClient('user'), {
    initialResponse: {},
  });

  const execute = (userAuthorityForm: BulkUpdateUserAuthorityForm) => {
    const path = 'user_authorities/bulk_update';
    api.execute(path, userAuthorityForm);
  };

  return { ...api, execute };
}
